import { useState ,useEffect} from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  TextField,
  Box,
  IconButton,
} from "@mui/material";
import {
  Add as AddIcon,
  Close as CloseIcon,
  Notes as NotesIcon,
} from "@mui/icons-material";
import { 
  SavePropertyNote, 
  GetPropertyNotes, 
  DeletePropertyNote
} from "../logic/PropertyNoteslogic";
import AddEmployeeDoodle from "images/AddEmployeeDoodle.png";

const PropertyNotesTab = ({ rules, theme, jobID, workReqID }) => {
  // State management
  const [propertyNotesList, setPropertyNotesList] = useState([]);
  const [newNote, setNewNote] = useState(
    {
      observationID: 0,
      jobID: jobID,
      observationName: "PropertyNote",
      observationDescription: ""
    }
  );
  const [showNoteField, setShowNoteField] = useState(false);
  const [loading, setLoading] = useState(false);

  const loadNotes = async () => {
    setLoading(true);
    try {
      const response = await GetPropertyNotes(jobID, 0, workReqID);

      if(!response.isError){
        setPropertyNotesList(response.result)
      }
    } catch (error) {
      console.error("Error loading notes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(jobID){
      loadNotes();
    }
  }, [jobID]);

  useEffect(() => {
    if(propertyNotesList && propertyNotesList.length > 0){
      setShowNoteField(true);
    }
  }, [propertyNotesList]);

  useEffect(() => {
    console.log('propertyNotesList', propertyNotesList)
  }, [propertyNotesList]);

  // Add new note
  const handleAddNote = async () => {
    if (jobID && newNote?.observationDescription?.trim()) {
      setLoading(true);
      try {
        const result = await SavePropertyNote(newNote);
        
        if (result && !result.isError) {
          // Refresh the notes list after successful save
          const notesResponse = await GetPropertyNotes(jobID, 0);
          setPropertyNotesList(prev => [{
            ...prev,
            notesResponse
          }]);
          setNewNote({
              observationID: 0,
              jobID: jobID,
              observationName: "PropertyNote",
              observationDescription: ""
          });
          loadNotes();
        }
      } catch (error) {
        console.error("Error adding note:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  // Delete note
  const handleDeleteNote = async (observationID) => {
    setLoading(true);
    try {
      const result = await DeletePropertyNote(observationID, jobID);
      
      if (result && !result.isError) {
        // Remove from local state
        // setPropertyNotesList(propertyNotesList.filter(note => note.id !== observationID));
        loadNotes();
      }
    } catch (error) {
      console.error("Error deleting note:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {showNoteField ? (
        <Card sx={{ mb: 3 }}>
          <CardContent>
           

            {/* Input Section */}
            <Box sx={{ mb: propertyNotesList?.length > 0 ? 3 : 0 }}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Add Property Notes
              </Typography>
              <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
                <TextField
                  fullWidth
                  placeholder="Enter note..."
                  value={newNote?.observationDescription}
                  onChange={(e) => setNewNote(prev => ({
                    ...prev,
                    observationDescription: e.target.value
                  }))}
                  disabled={!rules?.canEdit}
                />
                <IconButton
                  onClick={handleAddNote}
                  disabled={!newNote?.observationDescription?.trim() || !rules?.canEdit}
                  color="primary"
                  sx={{
                    minWidth: "auto",
                    height: "56px",
                    border: "1px solid",
                    borderRadius: 1,
                    "&:hover": {
                      backgroundColor: "action.hover",
                    },
                  }}
                >
                  <AddIcon />
                </IconButton>
              </Box>
            </Box>

            {/* Notes List */}
            {propertyNotesList && propertyNotesList?.length > 0 && (
              <Box>
                <Typography variant="subtitle1" sx={{ mb: 2 }}>
                  Notes ({propertyNotesList?.length})
                </Typography>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  {propertyNotesList?.map((note, index) => (
                    <Box
                      key={note.index}
                      sx={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 2,
                        p: 2,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 2,
                        backgroundColor: "background.paper",
                      }}
                    >
                      <Typography variant="body1">{index + 1}.</Typography>
                      <Box sx={{ flex: 1 }}>
                        <Typography variant="body1">{note?.observationDescription}</Typography>
                      </Box>
                      <IconButton
                        onClick={() => handleDeleteNote(note?.observationID)}
                        size="small"
                        color="primary"
                        disabled={!rules?.canEdit}
                        sx={{ mt: -0.5 }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </CardContent>
        </Card>
      ) : (
       <Box sx={{ position: "relative", width: "100%" }}>
  {/* Button positioned top right */}
  <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
    <Button
      variant="contained"
      color="main"
      startIcon={<AddIcon />}
      onClick={() => setShowNoteField(true)}
      disabled={!rules?.canEdit}
    >
      Add Property Notes
    </Button>
  </Box>

  {/* Empty state box */}
   <Box
  sx={{
    display: "flex",
    justifyContent: "center",
    mx: "auto",
    border: "1px solid #EAEAEA",
    borderRadius: 1,
    width: "100%",
    height: 280,
    py: 4,
    alignItems: "center" ,
  }}
>
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 2,
      justifyContent: "center",
      alignItems: "center",
      width: { xs: "90%", sm: "100%" }, 
      maxWidth: 400, 
      px: 2,
      textAlign: "center" 
    }}
  >
                <img
                  src={AddEmployeeDoodle}
                  alt="Empty State"
                  style={{ width: "100px", height: "auto" }}
                />
                <Typography variant="h6">No Property Notes added yet</Typography>
              </Box>
            </Box>
</Box>
      )}
    </Box>
  );
};

export default PropertyNotesTab;
